export const pixelsToPngUrl = ({
  height,
  pixels,
  width,
}: {
  height: number;
  pixels: Uint8ClampedArray;
  width: number;
}): string => {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  canvas
    .getContext('2d')
    ?.putImageData(
      new ImageData(new Uint8ClampedArray(pixels), width, height),
      0,
      0,
    );

  return canvas.toDataURL('image/png');
};
